import React, { Component } from "react";
import {
  Box,
  Tabs, Tab,
  Text,
  Grommet
} from 'grommet';
import Incident from './Incident';
import Maintenance from './Maintenance';
import ConfigConsole from './ConfigConsole';
import SLAConfig from "./SLAConfig";
import MaintenanceExecutionChecklist from './MaintenanceExecutionChecklist';
import AppVersions from './AppVersions';
import AviatorVersions from './AviatorVersions';
import HeadBar from '../views/HeadBar';
import InstanceForm from "../components/InstanceForm";
import { Modal, Button, Switch } from 'antd';
import { withAuthenticator } from '@aws-amplify/ui-react';
import { getUserGroups } from '../utils/auth';
import './OpsManTheme.css';

// Cognito group name that grants access to all ops tabs.
// Create this group in the Cognito user pool and add privileged users to it.
const OPS_ADMIN_GROUP = 'ops-admins';

const RichTabTitle = ({ label, active }) => {
  return (
    <Box direction="row" align="center" gap="small" margin="small" >
      <Text size="16px">
        {active ? (<strong>{label}</strong>) : label}
      </Text>
    </Box>
  )
};

const customTheme = {
  global: {
    colors: {
      focus: "none"
    },
  },
  tab: {
    border: {
      color: "transparent",
      size: "3px"
    },
    active: {
      color: "dark-1"
    },
    pad: {
      horizontal: "small"
    }
  },
  tabs: {
    header: {
      background: "#f6f6f6",
    },
  }
};

const customThemeDark = {
  global: {
    colors: {
      focus: "none"
    },
  },
  tab: {
    border: {
      color: "transparent",
      size: "3px"
    },
    active: {
      color: "light-1"
    },
    pad: {
      horizontal: "small"
    }
  },
  tabs: {
    header: {
      background: "#151a24",
    },
  }
};


class OpsMan extends Component {

  constructor(props) {
    super(props);
    const darkMode = localStorage.getItem('ops-dark-mode') === '1';
    const isAdmin = getUserGroups().includes(OPS_ADMIN_GROUP);
    // Tab indices must match those in render()
    const appVersionsTabIndex = isAdmin ? 5 : 0;
    this.state = {
      index: appVersionsTabIndex, // Default to ESM Farm App Version tab
      darkMode,
      isAdmin,
    }
  }

  componentDidMount() {
    // Re-evaluate groups after auth initialization and force app-only users to App Version History.
    const isAdmin = getUserGroups().includes(OPS_ADMIN_GROUP);
    const appVersionsTabIndex = isAdmin ? 5 : 0;
    this.setState({
      isAdmin,
      index: appVersionsTabIndex,
    });
  }

  onActive = index => this.setState((prev) => ({ index: prev.isAdmin ? index : 0 }));

  toggleDarkMode = (darkMode) => {
    localStorage.setItem('ops-dark-mode', darkMode ? '1' : '0');
    this.setState({ darkMode });
  }

  showInstanceModal = () => {
    this.setState({
      instanceModalVisible: true,
    });
  };

  handleInstanceModalCancel = e => {
    console.log(e);
    this.setState({
      instanceModalVisible: false,
    });
    window.location.reload();
  };

  render() {
    const { index, darkMode, isAdmin } = this.state;
    const configTabIndex = 0;
    const incidentTabIndex = 1;
    const maintenanceTabIndex = 2;
    const slaTabIndex = 3;
    const checklistTabIndex = 4;
    const appVersionsTabIndex = 5;
    const aviatorTabIndex = 6;

    return (

      <Grommet theme={darkMode ? customThemeDark : customTheme}>
        <div className={`ops-shell ${darkMode ? 'ops-dark' : 'ops-light'}`}>
          <HeadBar />
          <Box
            direction="row"
            justify="end"
            align="center"
            margin={{ horizontal: 'medium', top: 'small', bottom: 'xsmall' }}
            gap="small"
          >
            <Text size="small">Dark mode</Text>
            <Switch checked={darkMode} onChange={this.toggleDarkMode} />
          </Box>
          {isAdmin ? (
            <Tabs activeIndex={index} onActive={this.onActive}>
              <Tab title={
                <RichTabTitle
                  label="CONFIGURATIONS" active={index === configTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                //background="accent-1"
                >
                  <Button type="primary" onClick={this.showInstanceModal} >Create new farm</Button>
                  <ConfigConsole />
                  <Modal
                    title="Create new farm"
                    visible={this.state.instanceModalVisible}
                    onCancel={this.handleInstanceModalCancel}
                    footer={null}
                  >
                    <InstanceForm onSubmit={this.handleInstanceModalCancel} />
                  </Modal>
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="INCIDENT REPORT" active={index === incidentTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                //background="accent-2"
                >
                  <Incident />
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="PLANNED MAINTENCE SCHEDULE" active={index === maintenanceTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                //background="accent-1"
                >
                  <Box direction="row" width="100%" justify="center" margin={{ bottom: 'small' }}>
                    <Button type="primary" onClick={() => this.props.history.push('/maintenance-labels')}>
                      View By Label
                    </Button>
                  </Box>
                  <Maintenance />
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="SLA CONFIGURATOR" active={index === slaTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                //background="accent-1"
                >
                  <SLAConfig />
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="MAINTENANCE EXECUTION CHECKLIST" active={index === checklistTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                >
                  <MaintenanceExecutionChecklist />
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="ESM FARM APP VERSION" active={index === appVersionsTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                >
                  <AppVersions />
                </Box>
              </Tab>
              <Tab title={
                <RichTabTitle
                  label="AVIATOR FARM APP" active={index === aviatorTabIndex}
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                >
                  <AviatorVersions />
                </Box>
              </Tab>
            </Tabs>
          ) : (
            <Tabs activeIndex={0} onActive={() => {}}>
              <Tab title={
                <RichTabTitle
                  label="ESM FARM APP VERSION" active
                />
              }>
                <Box
                  margin="small"
                  pad="xxlarge"
                  align="center"
                >
                  <AppVersions />
                </Box>
              </Tab>
            </Tabs>
          )}
          {/* <FootBar/> */}
        </div>
      </Grommet>

    );
  }
}

export default withAuthenticator(OpsMan);